import ExcelIcon from "./Excelcon";

export default ExcelIcon;